module.exports = __webpack_public_path__ + "img/grounds-landscape_port.b47ea908.jpg";